import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { InputComponent } from '../input/input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';
import TYPES from '../../constants/types';
import { Psychologist } from '../../models/psychologists';

@Component({
  selector: 'app-select-one-psychologist',
  imports: [
    InputComponent,
    ButtonComponent,
    TranslatePipe,
    ReactiveFormsModule,
  ],
  templateUrl: './select-one-psychologist.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './select-one-psychologist.component.scss'
})
export class SelectOnePsychologistComponent {

  searchControl: UntypedFormControl;
  list: Psychologist[] = [];

  dialogRef = inject<DialogRef<{}>>(DialogRef<{}>);
  data = inject(DIALOG_DATA);

  BUTTON_TYPES: any;

  constructor(){
    this.searchControl = new UntypedFormControl('', []);

    this.searchControl.valueChanges.subscribe((value) => {
      this.list = this.data.list.filter((item: Psychologist) => {
        if(item.first_name && item.last_name)
          return item.first_name.toUpperCase().includes(value.toUpperCase()) || item.last_name.toUpperCase().includes(value.toUpperCase());
        return false;
      })
    });

    this.list = this.data.list;

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  cancel(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    this.dialogRef.close();
  }

  select(selectedItem: Psychologist){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    this.dialogRef.close({selectedItem});
  }

  getLanguageLabel(languages: string[]){    
    let languagesString = '';
    for(const language of TYPES.LANGUAGES){
      if(languages.includes(language.code)){
        languagesString += language.name+', '
      }
    }
    return languagesString.slice(0, languagesString.length-2);
  }

}
